module.exports = new __parcel__URL__("ride_3.506fe573.mp3").toString();